import type { LocaleCode } from '@/i18n/locales'
import type { TermsPageLocaleContent } from '../types'
import { termsPageEn } from './en'
import { termsPageEs } from './es'

const termsByLocale: Partial<Record<LocaleCode, TermsPageLocaleContent>> = {
  en: termsPageEn,
  es: termsPageEs,
}

export function getTermsPageContent(locale: LocaleCode): TermsPageLocaleContent {
  return termsByLocale[locale] ?? termsPageEn
}
